/**
 * The "+" on product tiles = add to cart.
 * One-variant, in-stock products are added straight to the cart and the
 * cart drawer opens (same flow as the product page's Add to cart button).
 * Products with several variants (or sold out) open the product page instead.
 */
(function () {
  if (window.__vCardPlusAdd) return;
  window.__vCardPlusAdd = true;

  function flash(btn, text) {
    var old = btn.getAttribute('data-plus') || '+';
    btn.textContent = text;
    setTimeout(function () {
      btn.textContent = old;
      btn.removeAttribute('aria-disabled');
    }, 1300);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.card__plus-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      window.location.href = btn.getAttribute('data-product-url');
      return;
    }

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = '…';

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (cart) {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    config.body = body;

    fetch(window.routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) {
          flash(btn, '!');
          return;
        }
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'card-plus', productVariantId: variantId, cartData: state });
        }
        cart.renderContents(state);
        flash(btn, '✓');
      })
      .catch(function () { flash(btn, '!'); });
  });
})();
